import React, { useState, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Modal, { ImpressumContent, PrivacyContent } from './LegalModals';
import { getStats } from '../supabase/supabase';

const { FiMail, FiBarChart2 } = FiIcons;

const Footer = () => {
  const [activeModal, setActiveModal] = useState(null);
  const [viewCount, setViewCount] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      const stats = await getStats();
      const totalViews = stats.find(s => s.key === 'total_page_views');
      if (totalViews) {
        setViewCount(totalViews.count);
      }
    };

    fetchStats();
    // Optional: Alle 30 Sekunden aktualisieren
    const interval = setInterval(fetchStats, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <footer className="bg-white border-t border-stone-100 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-12 text-center md:text-left">
          <div className="flex flex-col items-center md:items-start">
            <div className="flex items-center mb-6 justify-center md:justify-start">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/6a4e1632643f5ecd6b4b884d4518abad28ee28269a896d1a9bb8c081180db7d41fc79629d873bafacdf5fb95106d974d/images/aW1hZ2UvcG5n/c332d3ba3f3684a0e8ee690d3e7299be.png" 
                alt="CoreUnit Systems Logo" 
                className="h-24 md:h-32 w-auto object-contain" 
              />
            </div>
            <p className="text-stone-500 text-sm max-w-xs">
              Innovation in der pharmazeutischen Wirkstoffproduktion.<br />
              Strategisch gelegen an der A28.
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end gap-6">
            <div className="flex items-center gap-2 text-stone-600 bg-stone-50 px-5 py-3 rounded-xl border border-stone-100">
              <SafeIcon icon={FiMail} className="text-emerald-600" />
              <span className="text-sm font-semibold">info@coreunit-systems.de</span>
            </div>
            
            <div className="flex flex-wrap justify-center gap-8">
              <button 
                onClick={() => setActiveModal('impressum')} 
                className="text-stone-400 hover:text-emerald-600 text-sm font-medium transition-colors"
              >
                Impressum
              </button>
              <button 
                onClick={() => setActiveModal('privacy')} 
                className="text-stone-400 hover:text-emerald-600 text-sm font-medium transition-colors"
              >
                Datenschutz
              </button>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-stone-50 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-stone-400 text-xs text-center md:text-left">
            © {new Date().getFullYear()} CoreUnit Systems – Martin Habibi. Alle Rechte vorbehalten.
          </p>
          
          {viewCount !== null && (
            <div className="flex items-center gap-2 px-3 py-1 bg-stone-50 border border-stone-100 rounded-full">
              <SafeIcon icon={FiBarChart2} className="text-emerald-500 text-xs" />
              <span className="text-[10px] font-bold text-stone-500 uppercase tracking-tighter">
                {viewCount.toLocaleString()} Aufrufe
              </span>
            </div>
          )}
        </div>
      </div>

      <Modal isOpen={activeModal === 'impressum'} onClose={() => setActiveModal(null)} title="Impressum" >
        <ImpressumContent />
      </Modal>
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Datenschutz" >
        <PrivacyContent />
      </Modal>
    </footer>
  );
};

export default Footer;